import { Ref, computed, ref } from "@vue/composition-api";

export const UseCarousel = <T>(payload: {
  seed: T[];
  uniq_prop: keyof T;
  start_index: number;
}) => {
  const { seed, start_index, uniq_prop } = payload;

  const current_index = ref(start_index);
  const items: Ref<T[]> = ref(seed);
  const length = computed(() => items.value.length);

  const current_item = computed(() => items.value[current_index.value]);

  const reset_seed = (new_seed: T[], start: number) => {
    current_index.value = start;
  };

  const prev = () => {
    if (current_index.value === 0) {
      current_index.value = items.value.length - 1;
    } else {
      current_index.value--;
    }
  };

  const next = () => {
    if (current_index.value === items.value.length - 1) {
      current_index.value = 0;
    } else {
      current_index.value++;
    }
  };

  const add = (item: T) => {
    items.value = items.value.concat(item);
  };

  const remove = (item: T) => {
    items.value = items.value.filter((d) => d[uniq_prop] === item[uniq_prop]);
  };

  return {
    current_item,
    prev,
    next,
    add,
    remove,
    reset_seed,
    current_item_index: computed(() => current_index.value),
    length,
  };
};

export const UseSimpleCarousel = <T>(seed: T[]) => {
  const current_index = ref(0);
  const items: Ref<T[]> = ref(seed);
  const length = computed(() => items.value.length);

  const current_item = computed(() => items.value[current_index.value]);

  const reset_seed = (new_seed: T[], start: number) => {
    current_index.value = start;
  };

  const prev = () => {
    if (current_index.value === 0) {
      current_index.value = items.value.length - 1;
    } else {
      current_index.value--;
    }
    return items.value[current_index.value];
  };

  const next = () => {
    if (current_index.value === items.value.length - 1) {
      current_index.value = 0;
    } else {
      current_index.value++;
    }
    return items.value[current_index.value];
  };

  const add = (item: T) => {
    items.value = items.value.concat(item);
  };

  const remove = (item: T) => {
    items.value = items.value.filter((d) => d !== item);
  };

  return {
    current_item,
    prev,
    next,
    add,
    remove,
    reset_seed,
    current_item_index: computed(() => current_index.value),
    length,
  };
};
